import React from 'react'
import { connect } from 'react-redux'
import { withNamespaces } from "react-i18next"

class StepBarTime extends React.Component {

  getGradientStyle() {
    const { qrData } = this.props;
    if (qrData?.headerConfig?.primaryColor && qrData?.headerConfig?.secondaryColor) {
      return `linear-gradient(90deg, ${qrData.headerConfig.primaryColor}, ${qrData.headerConfig.secondaryColor})`;
    }
    return 'linear-gradient(90deg, #01315f, #067ddb)';
  }

  getButtonGradientStyle() {
    const { qrData } = this.props;
    if (qrData?.headerConfig?.buttonColor1 && qrData?.headerConfig?.buttonColor2) {
      return `linear-gradient(135deg, ${qrData.headerConfig.buttonColor1}, ${qrData.headerConfig.buttonColor2})`;
    }
    return 'linear-gradient(135deg, #01315f, #067ddb)';
  }

  getPrimaryTextColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.textPrimary || '#01315f';
  }

  render() {
    const { step, t } = this.props;
    const { qrData } = this.props;
    const gradient = this.getGradientStyle();
    const primaryColor = qrData?.headerConfig?.primaryColor || '#01315f';
    const iconsColor = qrData?.headerConfig?.iconsColor || primaryColor;

    const steps = [
      { label: t('Zona'),     icon: 'fa-map-marker-alt' },
      { label: t('Taquilla'), icon: 'fa-lock'            },
      { label: t('Datos'),    icon: 'fa-user'            },
      { label: t('Pago'),     icon: 'fa-credit-card'     },
      { label: t('Ticket'),   icon: 'fa-ticket-alt'      },
    ];

    return (
      <>
        <style>{`
          @keyframes timeStepColorLoop {
            0%   { background-position: 0% 50%; }
            50%  { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .time-stepbar-fixed {
            background: ${gradient} !important;
            border-top: none !important;
            box-shadow: 0 -2px 12px rgba(0,0,0,0.18) !important;
          }
          .time-step-number {
            background: rgba(255,255,255,0.2) !important;
            color: rgba(255,255,255,0.7) !important;
          }
          .time-step-label {
            color: rgba(255,255,255,0.7) !important;
          }
          .time-step-divider {
            background: rgba(255,255,255,0.25) !important;
          }
          .time-step.active .time-step-number {
            background: rgba(255,255,255,0.95) !important;
            background-size: 200% 200% !important;
            animation: none !important;
            color: ${iconsColor} !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2) !important;
          }
          .time-step.active .time-step-label {
            color: white !important;
            font-weight: 700 !important;
          }
          .time-step.done .time-step-number {
            background: rgba(255,255,255,0.4) !important;
            color: white !important;
          }
          .time-step.done .time-step-label {
            color: rgba(255,255,255,0.85) !important;
          }
          .time-step-divider.done {
            background: rgba(255,255,255,0.5) !important;
          }
        `}</style>
        <div className="time-stepbar-fixed">
          <div className="time-stepbar">
            {steps.map((s, i) => {
              const num      = i + 1;
              const isActive = step === num;
              const isDone   = step > num;
              return (
                <React.Fragment key={i}>
                  {i > 0 && (
                    <div className={`time-step-divider${isDone ? ' done' : ''}`} />
                  )}
                  <div className={`time-step${isActive ? ' active' : ''}${isDone ? ' done' : ''}`}>
                    <div className="time-step-number">
                      {isDone
                        ? <i className="fas fa-check" />
                        : <i className={`fas ${s.icon}`} />
                      }
                    </div>
                    <span className="time-step-label">{s.label}</span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
});

export default connect(mapStateToProps)(withNamespaces()(StepBarTime))
